import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, renderSlot as _renderSlot, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "p-header-navi-switch-button-for-sp-layout"
}
const _hoisted_2 = { class: "p-header-navi-switch-button-for-sp-layout__button__icon" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconLoop = _resolveComponent("IconLoop")!
  const _component_IconBase = _resolveComponent("IconBase")!

  return (!_ctx.ssoFlg)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("button", {
          class: "p-header-navi-switch-button-for-sp-layout__button",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.emitClickEvent()))
        }, [
          _createElementVNode("i", _hoisted_2, [
            _createVNode(_component_IconBase, {
              width: 16,
              height: 16,
              viewBox: "0 0 24 24",
              "icon-color": _ctx.colorCode
            }, {
              default: _withCtx(() => [
                _createVNode(_component_IconLoop)
              ]),
              _: 1
            }, 8, ["icon-color"])
          ]),
          _createElementVNode("span", {
            class: "p-header-navi-switch-button-for-sp-layout__button__text",
            style: _normalizeStyle({ color: _ctx.colorCode })
          }, [
            _renderSlot(_ctx.$slots, "default", {}, undefined, true)
          ], 4)
        ])
      ]))
    : _createCommentVNode("", true)
}